import { Component, OnInit } from '@angular/core';
import { Router,ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { tap, delay, finalize, catchError } from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import { of } from 'rxjs';

import { AuthService, WindowRefService } from '@app/core';
import * as moment from 'moment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  error: string;
  isLoading: boolean;
  returnUrl: string;
  loginForm: FormGroup;

  constructor(
    public translate: TranslateService,
    private winRef: WindowRefService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private authService: AuthService
  ) {
    this.buildForm();
    translate.setDefaultLang(this.winRef.appConfigSite.defaultlangue);
    translate.use(this.winRef.appConfigSite.defaultlangue);
    moment.locale(this.winRef.appConfigSite.defaultlangue);
  }

  ngOnInit() {
      // get return url from route parameters or default to '/'
        this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/manager/list';
  }

  get f () {
    return this.loginForm.controls;
  }

  login() {
    this.isLoading = true;

    const credentials = this.loginForm.value;

    this.authService.login(credentials)
      .pipe(
//        delay(5000),
        tap(user => {
            if(user) {
                this.router.navigate([this.returnUrl])
            } else {
                this.error = "Invalid username or password"
            }
            
        }),
        finalize(() => this.isLoading = false),
        catchError(error => of(this.error = error))
      ).subscribe();
  }

  private buildForm(): void {
    this.loginForm = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

}
